"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _editIcon = _interopRequireDefault(require("../../../assets/svg/edit-icon.svg"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ItemButton = function ItemButton(_ref) {
  var onClick = _ref.onClick,
    onEdit = _ref.onEdit,
    description = _ref.description,
    showItem = _ref.showItem,
    id = _ref.id,
    smallDescription = _ref.smallDescription,
    viewDiversities = _ref.viewDiversities,
    viewWhyCompany = _ref.viewWhyCompany,
    viewWritingSection = _ref.viewWritingSection,
    viewSkills = _ref.viewSkills,
    showPrivate = _ref.showPrivate;
  return /*#__PURE__*/_react.default.createElement(_styled.Container, {
    id: id,
    className: showItem === id ? "toggle-titles ".concat(id, " open") : "toggle-titles ".concat(id),
    onClick: onClick,
    viewDiversities: viewDiversities,
    viewWhyCompany: viewWhyCompany,
    showPrivate: showPrivate,
    viewWritingSection: viewWritingSection,
    viewSkills: viewSkills
  }, /*#__PURE__*/_react.default.createElement(_styled.DescriptionWrapper, null, description, onEdit && /*#__PURE__*/_react.default.createElement(_styled.EditButton, {
    onClick: onEdit
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _editIcon.default,
    alt: "edit"
  }))), /*#__PURE__*/_react.default.createElement("span", null, smallDescription));
};
ItemButton.propTypes = {
  id: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  onEdit: _propTypes.default.func,
  showItem: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  smallDescription: _propTypes.default.string,
  viewDiversities: _propTypes.default.bool,
  viewWhyCompany: _propTypes.default.bool,
  showPrivate: _propTypes.default.bool,
  viewWritingSection: _propTypes.default.bool,
  viewSkills: _propTypes.default.bool
};
ItemButton.defaultProps = {
  description: '',
  smallDescription: '',
  viewDiversities: false,
  viewWhyCompany: false,
  showPrivate: false,
  viewSkills: false,
  viewWritingSection: false,
  onEdit: null
};
var _default = ItemButton;
exports.default = _default;